/* eslint-disable @typescript-eslint/naming-convention */
import { BlockTools } from "../../blockTools.js";
import styles from "../../assets/styles/graphSystem/display/inputDisplayManager.module.scss";
import { ConnectionPointType } from "smart-filters";
import { Color3, Color4 } from "core/Maths/math.color.js";
import { GetTextureInputBlockEditorData } from "../getEditorData.js";
export class InputDisplayManager {
    getHeaderClass(_nodeData) {
        return styles["constant"];
    }
    shouldDisplayPortLabels() {
        return false;
    }
    getHeaderText(nodeData) {
        const inputBlock = nodeData.data;
        const name = `${inputBlock.name} (${InputDisplayManager.GetBaseType(inputBlock.type)})`;
        return name;
    }
    static GetBaseType(type) {
        return ConnectionPointType[type];
    }
    getBackgroundColor(nodeData) {
        let color;
        const inputBlock = nodeData.data;
        switch (inputBlock.type) {
            case ConnectionPointType.Color3: {
                const inputColor = inputBlock.runtimeValue.value;
                const color3 = new Color3(inputColor.r, inputColor.g, inputColor.b);
                color = color3.toHexString();
                break;
            }
            case ConnectionPointType.Color4: {
                const inputColor = inputBlock.runtimeValue.value;
                const color4 = new Color4(inputColor.r, inputColor.g, inputColor.b, inputColor.a);
                color = color4.toHexString();
                break;
            }
            default:
                color = BlockTools.GetColorFromConnectionNodeType(inputBlock.type);
                break;
        }
        return color;
    }
    updatePreviewContent(nodeData, contentArea) {
        let value = "";
        const inputBlock = nodeData.data;
        switch (inputBlock.type) {
            case ConnectionPointType.Boolean:
                value = inputBlock.runtimeValue.value ? "True" : "False";
                break;
            case ConnectionPointType.Float:
                value = inputBlock.runtimeValue.value.toFixed(4);
                break;
            case ConnectionPointType.Texture: {
                if (inputBlock.editorData?.urlTypeHint === "video") {
                    value = "Video";
                }
                else {
                    const style = GetTextureInputBlockEditorData(inputBlock).flipY === false ? "transform: scaleY(-1); z-index: -1;" : "";
                    const src = inputBlock.editorData?.url || inputBlock.runtimeValue.value?.getInternalTexture()?.url;
                    value = src ? `<img src="${src}" style="${style}" class="texture-input-preview"/>` : "";
                }
                break;
            }
            case ConnectionPointType.Vector2:
                value = `(${inputBlock.runtimeValue.value.x.toFixed(4)}, ${inputBlock.runtimeValue.value.y.toFixed(4)})`;
        }
        contentArea.innerHTML = value;
        contentArea.classList.add(styles["input-block"]);
    }
}
//# sourceMappingURL=inputDisplayManager.js.map